<div *ngIf="cart?.type !== orderTypes.returnableOrder" class="spacing--margin-top search">
  <div class="search" data-test="search">
    <p class="text--default" *ngIf="showAddProductsReminder">
      {{ 'cart-overview.direct-search-description' | translate }}
    </p>
    <div data-test="search__direct">
      <div class="search__container">
        <app-product class="search__container__buttons" [cart]="cart"></app-product>
        <app-search-favorites
          *ngIf="showFavoritesSearch && isFavoritesEnabled$ | async"
          class="search__container__buttons"
          [editable]="editable"
          [cart]="cart"
        ></app-search-favorites>
      </div>
    </div>
  </div>
</div>
